import { z } from "zod";
export const PracticeWordSchema = z.object({
    word: z.string().min(1),
    meaning: z.string().min(1),
    vietnamese: z.string().nullable(),
});
export const ReadingPassageSchema = z.object({
    title: z.string().min(1),
    passage: z.string().min(1),
    vietnamese_translation: z.string().min(1),
    words: z.array(PracticeWordSchema).min(1),
});
export const WritingPromptSchema = z.object({
    prompt: z.string().min(1),
    scenario_vi: z.string().min(1),
    words: z.array(PracticeWordSchema).min(1),
});
export const WritingFeedbackRequestSchema = z.object({
    prompt: z.string().min(1).max(1000),
    words: z.array(z.string().min(1)).max(8).default([]),
    text: z.string().min(1).max(3000),
});
export const WritingCorrectionSchema = z.object({
    quote: z.string().min(1),
    issue_vi: z.string().min(1),
    suggestion: z.string().min(1),
});
export const WritingWordUsageSchema = z.object({
    word: z.string().min(1),
    used: z.boolean(),
    natural: z.boolean(),
    comment_vi: z.string(),
});
export const WritingFeedbackSchema = z.object({
    rating: z.enum(["excellent", "good", "needs_work"]),
    summary_vi: z.string().min(1),
    corrections: z.array(WritingCorrectionSchema),
    word_usage: z.array(WritingWordUsageSchema),
    improved_version: z.string().min(1),
});
//# sourceMappingURL=practice.js.map